import { useEffect, useRef } from 'react';

import { useEnvironment } from '#/contexts/UserEnvironmentContext';
import { useI18n } from '#/i18n/hooks/useI18n';
import { useEmbedSearchWidgetLayoutRouteLoaderData } from '#/modules/embedSearchWidget/hooks/useEmbedSearchWidgetLayoutRouteLoaderData';
import {
  useSearchActions,
  useSearchLocation,
} from '#/modules/search/contexts/SearchContext';
import { searchGetInitialLocation } from '#/modules/search/helpers/searchGetInitialLocation';

export function UpdateSearchLocationFromLocalStorageGlobalHandler() {
  const { embedSearchWidgetSearchLocation } =
    useEmbedSearchWidgetLayoutRouteLoaderData();
  const { locale } = useI18n();
  const { environment } = useEnvironment();

  const searchLocation = useSearchLocation();
  const { updateSearchLocation } = useSearchActions();

  const triggeredRef = useRef(false);

  useEffect(() => {
    async function handleInitialSearchLocation() {
      if (!environment) return;

      const initialSearchLocation = await searchGetInitialLocation(
        environment.guessedLocation,
        locale,
        embedSearchWidgetSearchLocation,
      );

      updateSearchLocation(initialSearchLocation, false);
    }

    if (!environment || triggeredRef.current) return;
    triggeredRef.current = true;

    if (!searchLocation) {
      void handleInitialSearchLocation();
    }
  }, [
    embedSearchWidgetSearchLocation,
    environment,
    locale,
    searchLocation,
    updateSearchLocation,
  ]);

  return null;
}
